import Vue from 'vue';
import Component from 'vue-class-component';
import { Observer } from "mobx-vue";

import Navigation from '@/components/Navigation';
import Drawer from '@/components/Drawer';
import Logo from '@/components/Logo';
import EntryList from '@/components/Entry/EntryList';
import Menu from '@/components/Menu';
import Icon from '@/components/Icon';
import MyFocus from '@/components/MyFocus';
import ModalList from '@/components/Modal';
import Dialog from '@/components/Dialog';
import DeviceNumber from '@/components/Dialog/DeviceNumber';
import Rename from '@/components/Dialog/Rename';
import RestoreAndRestart from '@/components/Dialog/RestoreAndRestart';

import SigninStory from '@/store/SigninStore';
import HomeStore, {ModalStateName} from '@/store/HomeStore';
import ModalStore from '@/store/ModalStore';
import GlobalStore from '@/store/GlobalStore';
import PackageStore from '@/store/PackageStore';
import Log from '@/components/Log';

import '@/style/home.less';

@Observer
@Component
export default class Home extends Vue {

  state = {
    SigninStory,
    HomeStore,
    ModalStore,
    GlobalStore,
    PackageStore
  }

  async mounted () {
    console.log('首页');
    await this.state.HomeStore.getPolicyDot()
    await this.state.ModalStore.getNotifications()
    await this.state.HomeStore.getCloudDeviceList()
    await this.state.GlobalStore.getInitialize()
    this.state.PackageStore.setUserItemId(null)
    await this.state.HomeStore.uaBlackListRequest()
    this.state.HomeStore.testingWebRTC()
  }

  render () {
    return (
      <div class='card'>
        <Navigation
          left={<Icon click={() =>this.state.HomeStore.drawerShow()}  name='me'/>}
          title='爱云兔云手机'
          right={<Log number='A090'><Icon click={this.state.HomeStore.routerPushCustomer} name='customer'/></Log>}/>

        <Drawer hide={() => this.state.HomeStore.drawerHide()} visible={this.state.HomeStore.drawerVisible} >
          <Logo style='margin-bottom: 1.71429vw;' className='home-logo' />
          <span class='drawer-title'>爱云兔云手机</span>
          <EntryList data={[this.state.HomeStore.saleCardInfo, this.state.HomeStore.couponInfo, this.state.HomeStore.pointCardInfo  ]} />
          <Menu events={{routerPush: this.state.HomeStore.routerPush}}/>
          <Log number='N0133'><div onClick={() =>
          { this.state.HomeStore.drawerHide()
            this.state.HomeStore.setModalState(ModalStateName.signoutModalState, true)}} class='signOut-button'>退出登录</div></Log>
        </Drawer>

        <MyFocus
          events={{
            routerPush: this.state.HomeStore.routerPush,
            modalVisible: (name: ModalStateName) => this.state.HomeStore.setModalState(name, true),
            cloudDevicePlay: this.state.HomeStore.cloudDevicePlay,
            swiperOnChange: this.state.HomeStore.swiperOnChange,
            cloudDeviceRefresh: this.state.HomeStore.cloudDeviceRefresh,
            routerPushPackage: this.state.HomeStore.routerPushPackage,
            routerPushCustomer: this.state.HomeStore.routerPushCustomer
          }}

          dataSource={this.state.HomeStore.cloudDeviceList} />

        <Dialog
          visible={this.state.HomeStore.renameModalState}
          cancel={() => this.state.HomeStore.setModalState(ModalStateName.renameModalState, false)}
          ok={() => this.state.HomeStore.cloudDeviceRename()}>
          <Rename change={this.state.HomeStore.renameInputOnChange} value={this.state.HomeStore.renameText}/>
        </Dialog>

        <Dialog
          visible={this.state.HomeStore.restartModalState}
          cancel={() => this.state.HomeStore.setModalState(ModalStateName.restartModalState, false)}
          ok={() => this.state.HomeStore.cloudDeviceReboot()}>
          <RestoreAndRestart type={1}/>
        </Dialog>

        <Dialog
          visible={this.state.HomeStore.restoreModalState}
          cancel={() => this.state.HomeStore.setModalState(ModalStateName.restoreModalState, false)}
          ok={() => this.state.HomeStore.cloudDeviceReset()}>
          <RestoreAndRestart type={0}/>
        </Dialog>

        <Dialog
          visible={this.state.HomeStore.deviceNumberModalState}
          cancel={() => this.state.HomeStore.setModalState(ModalStateName.deviceNumberModalState, false)}
          ok={() => this.state.HomeStore.setModalState(ModalStateName.deviceNumberModalState, false)}>
          <DeviceNumber cid={this.state.HomeStore.getActiveData().cid} />
        </Dialog>

        <Dialog
          visible={this.state.HomeStore.signoutModalState}
          cancel={() => this.state.HomeStore.setModalState(ModalStateName.signoutModalState, false)}
          ok={() => this.state.HomeStore.signout()}>
          <RestoreAndRestart type={2}/>
        </Dialog>

          <Dialog
              visible={this.state.HomeStore.webRTCModalState}
              cancel={() => this.state.HomeStore.setModalState(ModalStateName.webRTCModalState, false)}
              ok={() => window.location.href = 'https://51yuntu.haimawan.com?channel=004'}>
              <p style={{marginTop: '8.57143vw', marginBottom: '5.71429vw', textAlign: 'center', fontSize: '4.57143vw', fontWeight: '600'}}>您的浏览器无法使用云手机</p>
              <p style={{marginTop: '5.71429vw', marginBottom: '5.71429vw', textAlign: 'center',fontSize: '4vw', lineHeight: '5.71429vw'}}>请到微信搜索"爱云兔官方服务号"<br/>或下载客户端使用</p>
          </Dialog>

        <ModalList dataSource={this.state.ModalStore.modalVisible}/>
        <Log type='hooks' number='H000' />
      </div>
    )
  }

}
